import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useAuth } from '@/providers/AuthProvider';

export const Route = createFileRoute('/')({
  component: IndexComponent,
});

function IndexComponent() {
  const { isAuthenticated, isAdmin, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading) {
      if (!isAuthenticated) {
        navigate({ to: '/login', replace: true });
      } else if (!isAdmin) {
        navigate({ to: '/access-denied', replace: true });
      } else {
        navigate({ to: '/admin/user-management', replace: true });
      }
    }
  }, [isLoading, isAuthenticated, isAdmin, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#4A7C7E]"></div>
    </div>
  );
}